export const palette = {
  alternate: {
    main: '#F9F6FF',
    light: '#F9F8F8',
    dark: '#E5EAF4',
  },
  cardShadow: 'rgba(23, 70, 161, .11)',
  type: 'light',
  primary: {
    main: '#020202',
    light: '#e5e5e5',
    contrastText: '#FFFFFF'
  },
  secondary: {
    main: '#020202',
    contrastText: '#0A5285',
    light: '#D9EDF7'
  },
  text: {
    primary: '#0E2E3B',
    secondary: '#4A5462',
    alternate: '#23B0E7',
    disabled: '#CCC',
    highlight: '#FFF',
    success: '#1CA179',
    border: '#E5EAF4',
    arrow:'#292D32'
  },
  divider: 'rgba(52, 53, 56, 0.4)',
  background: {
    main: '#B4C08F',
    addon: '#F7F7F7',
    subscription: '#B4C08F',
    card: '#FAFAEE',
    paper: '#FFF',
    default: '#FFF',
    header: 'linear-gradient(to right, rgba(160, 182, 188, 1), rgba(217, 225, 221, 1))',
    footer: '#F9F9ED',
    level2: '#f7f8fb',
    level1: 'rgba(255, 255, 255, 0.6)',
    steps: '#B4C08F',
    tableHead: '#B4C08F',
    tableSubhead: '#F7F7F7',
    tableBorder: '#7D808880',
    tableAlternate: '#F8F8F8',
    alternate: '#d4f1f9',
    success: '#DBEFDC',
    error: '#FFEAEA',
    primary: 'linear-gradient(to right, #A0B6BC, #D9E1DD)',
    secondary: '#FEFFFA',
    light: '#ebe8e7',
    arrow: '#BACE60',
    secondaryLight: '#F9F9F5'
  },
  verticalBar: {
    used: '#020202',
    unused: '#e5e5e5',
    unlimited: '#C0C0C0',
  }
};